import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import brighten from './brighten';
const styles = {
  base: {
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: 3,
    padding: 4,
    marginLeft: 3,
    marginRight: 3,
    marginTop: 5,
    marginBottom: 5,
    flexGrow: 1,
    display: 'inline-block',
    fontSize: '0.8em',
    color: 'white',
    textDecoration: 'none'
  }
};
export default class LogMonitorButton extends React.PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      hovered: false,
      active: false
    });
    _defineProperty(this, "handleMouseEnter", () => {
      this.setState({
        hovered: true
      });
    });
    _defineProperty(this, "handleMouseLeave", () => {
      this.setState({
        hovered: false
      });
    });
    _defineProperty(this, "handleMouseDown", () => {
      this.setState({
        active: true
      });
    });
    _defineProperty(this, "handleMouseUp", () => {
      this.setState({
        active: false
      });
    });
    _defineProperty(this, "onClick", () => {
      if (!this.props.enabled) {
        return;
      }
      if (this.props.onClick) {
        this.props.onClick();
      }
    });
  }
  render() {
    let style = {
      ...styles.base,
      backgroundColor: this.props.theme.base02
    };
    if (this.props.enabled && this.state.hovered) {
      style = {
        ...style,
        backgroundColor: brighten(this.props.theme.base02, 0.2)
      };
    }
    if (!this.props.enabled) {
      style = {
        ...style,
        opacity: 0.2,
        cursor: 'text',
        backgroundColor: 'transparent'
      };
    }
    return /*#__PURE__*/React.createElement("a", {
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      onClick: this.onClick,
      style: style
    }, this.props.children);
  }
}